import { useSelector } from 'react-redux';

import { useProductContext } from '@techstyle/react-components';

import { ProductTag } from './productDetail';
import {
  getIsCriticalLowStock,
  getIsLowStock,
  getTagIdSet,
  getWarehouseQuantity,
} from './products';

export const Callout = {
  BACK_IN_STOCK: 'BACK_IN_STOCK',
  BEST_SELLER: 'BEST_SELLER',
  CRITICAL_STOCK: 'CRITICAL_STOCK',
  CUSTOM_TAG: 'CUSTOM_TAG',
  CUSTOMIZABLE: 'CUSTOMIZABLE',
  LOW_IN_STOCK: 'LOW_IN_STOCK',
  NEW: 'NEW',
  PRE_ORDER: 'PRE_ORDER',
  RIHANNAS_PICK: 'RIHANNAS_PICK',
  TOP_RATED: 'TOP_RATED',
  TRENDING: 'TRENDING',
  UNLOCKED_XCLUSIVE: 'UNLOCKED_XCLUSIVE',
  YOUNIVERSAL: 'YOUNIVERSAL',
};

const CalloutTag = {
  [Callout.BACK_IN_STOCK]: ProductTag.backInStock,
  [Callout.BEST_SELLER]: ProductTag.bestSeller,
  [Callout.CUSTOM_TAG]: ProductTag.customTag,
  [Callout.CUSTOMIZABLE]: ProductTag.customizable,
  [Callout.NEW]: ProductTag.new,
  [Callout.PRE_ORDER]: ProductTag.preOrder,
  [Callout.RIHANNAS_PICK]: ProductTag.rihannasPick,
  [Callout.TOP_RATED]: ProductTag.topRated,
  [Callout.TRENDING]: ProductTag.trending,
  [Callout.UNLOCKED_XCLUSIVE]: ProductTag.unlockedXclusive,
  [Callout.YOUNIVERSAL]: ProductTag.youniversal,
};

const calloutPriorityList = [
  Callout.PRE_ORDER,
  Callout.CUSTOMIZABLE,
  Callout.UNLOCKED_XCLUSIVE,
  Callout.CRITICAL_STOCK,
  Callout.LOW_IN_STOCK,
  Callout.YOUNIVERSAL,
  Callout.RIHANNAS_PICK,
  Callout.BACK_IN_STOCK,
  Callout.BEST_SELLER,
  Callout.TOP_RATED,
  Callout.NEW,
  Callout.TRENDING,
];

export default function useProductCallout({
  product: productFromProps,
  callouts = calloutPriorityList,
} = {}) {
  const productFromContext = useProductContext();
  const product = productFromProps || productFromContext;

  const tagIdSet = useSelector(state => getTagIdSet(state, { product }));
  const quantity = useSelector(state => {
    return getWarehouseQuantity(state, { product });
  });

  const isCriticalLowStock = useSelector(state =>
    getIsCriticalLowStock(state, { product })
  );
  const isLowStock = useSelector(state => getIsLowStock(state, { product }));

  for (const type of callouts) {
    switch (type) {
      case Callout.CRITICAL_STOCK: {
        if (isCriticalLowStock) {
          return { type, value: quantity };
        }
        break;
      }
      case Callout.LOW_IN_STOCK: {
        if (isLowStock) {
          return { type };
        }
        break;
      }
      case Callout.PRE_ORDER:
      case Callout.CUSTOMIZABLE:
      case Callout.UNLOCKED_XCLUSIVE:
      case Callout.RIHANNAS_PICK:
      case Callout.BACK_IN_STOCK:
      case Callout.BEST_SELLER:
      case Callout.TOP_RATED:
      case Callout.NEW:
      case Callout.YOUNIVERSAL:
      case Callout.TRENDING: {
        if (tagIdSet.has(CalloutTag[type])) {
          return { type };
        }
        break;
      }
      // Add additional callout logic here
      default:
        break;
    }
  }
  return null;
}
